import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import Layout from "./components/Layout";
import Login from "./components/Login";
import LocationSelection from "./components/LocationSelection";
import DinerSelection from "./components/DinerSelection";
import DinerProfile from "./components/DinerProfile";
import Checkout from "./components/Checkout";
import ProtectedRoute from "./components/ProtectedRoute";
import IndexRedirect from "./components/IndexRedirect";
import Refund from "./components/Refund";
import EnterCheckNumber from "./components/EnterCheckNumber";
import { RefundReason } from "./types";

interface AppProps {
  refund_reasons?: [string, string][];
}

const App: React.FC<AppProps> = ({ refund_reasons = [] }) => {
  // Convert Rails options_for_select format to our component format
  const formattedRefundReasons: RefundReason[] = refund_reasons.map(
    ([label, value]) => ({
      label,
      value,
    }),
  );

  return (
    <main className="web-redemption bsl-checkout">
      <Provider store={store}>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route
              path="*"
              element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<IndexRedirect />} />
                    <Route element={<ProtectedRoute />}>
                      <Route
                        path="/location-selection"
                        element={<LocationSelection />}
                      />
                      <Route
                        path="/diner-selection"
                        element={<DinerSelection />}
                      />
                      <Route path="/diner-profile" element={<DinerProfile />} />
                      <Route
                        path="/refund"
                        element={
                          <Refund refundReasons={formattedRefundReasons} />
                        }
                      />
                      <Route
                        path="/enter-check-number"
                        element={<EnterCheckNumber />}
                      />
                    </Route>
                  </Routes>
                </Layout>
              }
            />
          </Routes>
        </Router>
      </Provider>
    </main>
  );
};

export default App;
